import React from 'react'

function InputLabel({ text, htmlfor }) {
    return (
        <label htmlFor={htmlfor}>
            {text}
        </label>
    )
}

export default InputLabel